// extracted by mini-css-extract-plugin
export default {"enable-background":"LoadingAnimation_enable-background__o-xYJ","loader":"LoadingAnimation_loader__L+lJP"};